import client from './client';

export async function addFeedback(text: string, orderId: string, contact: string, objId: number = 0) {
    const text_ = text + '\n' + contact;
    const { data } = await client.POST('/api/v1/public/reviews', {
        body: {
            text: text_,
            order_id: orderId || '0',
            obj_id: objId || 0
        }
    });
    return data;
}